<script>
  const SELECTED = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 40"><g id="Layer_2" data-name="Layer 2"><g id="COMPANY_-_Bid_Manager" data-name="COMPANY - Bid Manager"><path class="cls-1" d="M24.15.5a9,9,0,0,0-8.72,6.79L8.72,33.71A9,9,0,0,1,0,40.5H24.74V.5Z"/><path class="cls-2" d="M24.15.5a9,9,0,0,0-8.72,6.79L8.72,33.71A9,9,0,0,1,0,40.5H24.74V.5Z"/></g></g></svg>';

  export let
    selected = false,
    onClick = () => {};
</script>


<div class="Component" class:Selected={selected} on:click={onClick}>
  <div class="LeftPart" class:Unselected={!selected}>{@html SELECTED}</div>
  <div class="MainPart" class:Unselected={!selected}><slot /></div>
  <div class="RightPart" class:Unselected={!selected}>{@html SELECTED}</div>
</div>

<style lang="stylus">

  .Component {
    display: flex;
    height: 40px;
    overflow hidden;
    margin-left: -25px;
    cursor: pointer;

    :global(.cls-1) {fill: #fff;}
    :global(.Unselected .cls-1) {fill: #cfd8dc;}
    :global(.cls-2) {fill:none; stroke: #CFD8DC; stroke-miterlimit:10;}
    :global(.Unselected .cls-2) {stroke: #fff;}

    &.Selected {
      position:relative;
      z-index: 1;
    }
  }

  .Component:first {
    margin-left: 0;
  }

  .LeftPart {
    height: 40px;
    margin-right: -2px;
    width: 25px;
    z-index: 0;
    position: relative;
  }

  .RightPart {
    transform: rotateY(180deg);
    height: 40px;
    width: 25px;
    position: relative;
    z-index: 0;
    margin-left: -2px;
  }

  .MainPart {
    height: 40px;
    padding: 0 15px;
    border-top: 1px solid #CFD8DC;
    background: white;
    display: inline-flex;
    justify-content: start;
    align-items: center;
    position: relative;
    z-index: 1;
    box-sizing: border-box;

    font-size: 13px;
    color: #455A64;

    &.Unselected {
      border-top: 1px solid #fff;
      background: #cfd8dc;
    }
  }

</style>
